import clsx from "clsx";

export const container = clsx(" w-full flex-col items-center overflow-hidden px-4");
export const slide = clsx("mb-12 max-w-[450px] rounded-md bg-white shadow-md");
export const img = clsx("rounded-t-md h-[300px] w-full object-cover");
export const desc = clsx(
    "bg-white min-h-[50px] text-center text-xs justify-center rounded-b-md flex items-center p-2",
);
export const counter = clsx("w-full text-center text-xs tracking-wider text-black/30");